import { Controller } from "@hotwired/stimulus"
 
export default class extends Controller {
  static targets = ["source", "filterable", "unread"]
  
  filter(event) {
    const unreadOnly = this.unreadTarget.checked;
    const lowerCaseFilterTerm = this.sourceTarget.value.toLowerCase()
    const filterFn = this.getFilterFn(unreadOnly, lowerCaseFilterTerm)
    this.filterableTargets.forEach((el, i) => {
      let filterableKey = el.getAttribute("data-filter-key")

      filterFn(el, filterableKey, lowerCaseFilterTerm)
    })
  }

  getFilterFn(unreadOnly, term) {
    if (unreadOnly && term.length > 0) {
      return this.filterByUnreadAndName
    } else if (unreadOnly) {
      return this.filterByUnread
    } else {
      return this.filterByName
    }
  }

  filterByUnreadAndName(element, key, term) {
    element.classList.toggle("hidden", !key.includes('unread:true') || !key.includes(term))
  }

  filterByUnread(element, key) {
    element.classList.toggle("hidden", !key.includes('unread:true'))
  }

  filterByName(element, key, term) {
    element.classList.toggle("hidden", !key.includes(term))
  }
}
